import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=1195fd0e&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/administrator/staffpanel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1195fd0e')) {
      api.createRecord('1195fd0e', component.options)
    } else {
      api.reload('1195fd0e', component.options)
    }
    module.hot.accept("./Token.vue?vue&type=template&id=1195fd0e&", function () {
      api.rerender('1195fd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Token.vue"
export default component.exports